export const internationalRelationsConst = {
  path: "/single-programs/international-relations",
  title: "ФАКУЛЬТЕТ ПОЛИТИЧЕСКИХ НАУК — МЕЖДУНАРОДНЫЕ ОТНОШЕНИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Международные отношения — профессия на пересечении политики, права и дипломатии</h2>
      <p>
        Эта программа создана для тех, кто стремится понимать глобальные процессы, участвовать в решении международных конфликтов и
        выстраивать диалог между государствами. Студенты изучают мировую политику, дипломатию, международное право, безопасность и
        геополитику.
      </p>
      <p>
        Международные отношения — это профессия будущего: специалисты с глубокими знаниями и аналитическим мышлением востребованы в
        посольствах, международных организациях, исследовательских центрах и транснациональных корпорациях.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Мировая политика и дипломатия</li>
        <li>Международное право и права человека</li>
        <li>Глобальные конфликты и безопасность</li>
        <li>Внешняя политика стран ЕС и мира</li>
        <li>Международные экономические отношения</li>
        <li>Институции ООН, НАТО, ЕС</li>
        <li>Геополитика и международная аналитика</li>
        <li>Этикет и протокол международной службы</li>
      </ul>
      <p>
        Программа ориентирована как на теоретическую подготовку, так и на практику — через симуляции переговоров, участие в конференциях и
        стажировки за рубежом.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Дипломат или сотрудник международной организации</li>
        <li>Аналитик международных процессов</li>
        <li>Специалист по внешней политике и международной безопасности</li>
        <li>Консультант по международному праву</li>
        <li>Политический обозреватель и исследователь</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€50,000 до €100,000 в год</strong> — особенно в институциях ЕС и международных НКО.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с международным признанием</li>
        <li>Обучение на русском или английском языке</li>
        <li>Возможность учиться дистанционно из любой точки мира</li>
        <li>Преподаватели с опытом в международных организациях</li>
        <li>Поддержка карьерного роста и стажировки в ЕС</li>
        <li>Гибкий подход к обучению и доступ к аналитическим платформам</li>
      </ul>
      <p>Международные отношения — это ваш путь в глобальный мир решений, диалога и влияния.</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия сопровождает вас на каждом этапе: от выбора программы до оформления документов.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Международные отношения — профессия на пересечении политики, права и дипломатии
    Эта программа создана для тех, кто стремится понимать глобальные процессы, участвовать в решении международных конфликтов и выстраивать диалог между государствами. Студенты изучают мировую политику, дипломатию, международное право, безопасность и геополитику.
    Международные отношения — это профессия будущего: специалисты с глубокими знаниями и аналитическим мышлением востребованы в посольствах, международных организациях, исследовательских центрах и транснациональных корпорациях.
    Что вы будете изучать?
    • Мировая политика и дипломатия
    • Международное право и права человека
    • Глобальные конфликты и безопасность
    • Внешняя политика стран ЕС и мира
    • Международные экономические отношения
    • Институции ООН, НАТО, ЕС
    • Геополитика и международная аналитика
    • Этикет и протокол международной службы
    Программа ориентирована как на теоретическую подготовку, так и на практику — через симуляции переговоров, участие в конференциях и стажировки за рубежом.
    Кем можно работать после окончания?
    • Дипломат или сотрудник международной организации
    • Аналитик международных процессов
    • Специалист по внешней политике и международной безопасности
    • Консультант по международному праву
    • Политический обозреватель и исследователь
    Зарплата в Европе: от €50,000 до €100,000 в год — особенно в институциях ЕС и международных НКО.
    Почему выбирают нас?
    • Европейский диплом с международным признанием
    • Обучение на русском или английском языке
    • Возможность учиться дистанционно из любой точки мира
    • Преподаватели с опытом в международных организациях
    • Поддержка карьерного роста и стажировки в ЕС
    • Гибкий подход к обучению и доступ к аналитическим платформам
    Международные отношения — это ваш путь в глобальный мир решений, диалога и влияния.
    Как поступить?
    Приёмная комиссия сопровождает вас на каждом этапе: от выбора программы до оформления документов.
  `,
};
